export const BASEMAP_STYLES = [
  {
    style: "outdoors-v11",
    name: "Outdoors",
    url: "mapbox://styles/mapbox/outdoors-v11",
  },
  {
    style: "streets-v11",
    name: "Streets",
    url: "mapbox://styles/mapbox/streets-v11",
  },
  {
    style: "satellite-streets-v11",
    name: "Satellite",
    url: "mapbox://styles/mapbox/satellite-streets-v11",
  },
  {
    style: "light-v10",
    name: "Light",
    url: "mapbox://styles/mapbox/light-v10",
  },
  {
    style: "dark-v10",
    name: "Dark",
    url: "mapbox://styles/mapbox/dark-v10",
  },
];

export const DEFAULT_MAP_CENTER = [-105.5496, 39.48661];

export const INIT_MAP_CONFIG = {
  style: BASEMAP_STYLES[0].url,
  center: DEFAULT_MAP_CENTER,
  zoom: 8.2,
  preserveDrawingBuffer: true,
};

export const WELLS_LAYER_ID = "denver-water-locations-circle";
export const WELLS_LABELS_LAYER_ID = "denver-water-locations-symbol";
export const INIT_FILTER_VALUES = {
  locationTypes: {
    label: "Location Types",
    name: "locationTypes",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "loc_type",
    options: [],
    type: "multi-select",
    value: [],
  },
  organizations: {
    name: "organizations",
    label: "Organizations",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "organizations",
    options: [],
    type: "multi-select-array",
    value: [],
  },
  basins: {
    name: "basins",
    label: "Basins",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "basin",
    options: [],
    type: "multi-select",
    value: [],
  },
  sources: {
    name: "sources",
    label: "Sources",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "sources",
    options: [],
    type: "multi-select-array",
    value: [],
  },
  locations: {
    name: "locations",
    label: "Locations",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "ndx",
    options: [],
    type: "locations-autocomplete",
    value: [],
  },
  graphMode: {
    layerId: WELLS_LAYER_ID,
    layerFieldName: "ndx",
    type: "graphMode",
    value: [""],
  },
  isAbasinName: {
    layerId: WELLS_LAYER_ID,
    layerFieldName: "abasin_point",
    type: "boolean",
    value: false,
  },
  isTreatmentPlantSource: {
    layerId: WELLS_LAYER_ID,
    layerFieldName: "treatment_point",
    type: "boolean",
    value: false,
  },
};

const layerId = "denver-water-locations-circle";
export const INIT_STYLE_VALUES = {
  default: {
    id: "default",
    layerId,
    layerFieldName: "",
    name: "Default",
    paint: {
      "circle-color": "#1e8dd2",
      "circle-stroke-width": 1,
      "circle-stroke-color": "#fff",
    },
  },
  locationTypes: {
    id: "locationTypes",
    layerId,
    layerFieldName: "loc_type",
    name: "Location Types",
    options: [],
    type: "multi-select",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "loc_type"],
        "No Values Available",
        "#fff",
        "#fff",
      ],
    },
  },
  organizations: {
    id: "organizations",
    layerId,
    layerFieldName: "organizations",
    name: "Organizations",
    options: [],
    type: "multi-select-array",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "organization"],
        "No Values Available",
        "#000000",
        "#000000",
      ],
    },
  },
  basins: {
    id: "basins",
    layerId,
    layerFieldName: "basin",
    name: "Basins",
    options: [],
    type: "multi-select",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "basin"],
        "No Values Available",
        "#000000",
        "#000000",
      ],
    },
  },
  sources: {
    id: "sources",
    layerId,
    layerFieldName: "sources",
    name: "Sources",
    options: [],
    type: "multi-select-array",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "source"],
        "No Values Available",
        "#000000",
        "#000000",
      ],
    },
  },
};
